import React from 'react';
import DatePicker from 'react-datepicker';
import { da } from 'date-fns/locale'; 
import 'react-datepicker/dist/react-datepicker.css';
import { formatDateToISO } from '../../utilities/dateUtils';

const MonthPicker = ({ selectedDate, onDateChange, currentDate }) => {
    const safeCurrentDate = currentDate || new Date();
    const maxDate = new Date(safeCurrentDate.getFullYear(), safeCurrentDate.getMonth() + 1, safeCurrentDate.getDate());
    const handleMonthChange = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const startDate = new Date(year, month, 1);
        const endDate = new Date(year, month + 1, 0);
        const adjustedStartDate = formatDateToISO(startDate);
        const adjustedEndDate = formatDateToISO(endDate);

        onDateChange(adjustedStartDate, adjustedEndDate, startDate, endDate);
    };
    return (
        <DatePicker 
            selected={selectedDate}
            onChange={handleMonthChange}
            showMonthYearPicker
            dateFormat="MM/yyyy"
            maxDate={maxDate} 
            minDate={new Date(2019, 0, 1)}
            locale={da}
        />
    );
}

export default MonthPicker;
